<script setup lang="ts">
import {
  ClassSelector,
  CounterTheme,
  CounterType
} from "~/components/Molecules/Counter.props"
import { DigitProps, DigitSize } from "./Digit.props"
import { getClass, getThemeClass } from "~/components/Molecules/Counter.util"

withDefaults(defineProps<DigitProps>(), {
  digit: "00",
  label: "",
  theme: CounterTheme.squared,
  type: CounterType.complete,
  digitSize: DigitSize["2xl"]
})
</script>
<template>
  <div
    :id="`counter-digit-${label}`"
    class="relative min-w-max text-center"
    :class="[
      ...getThemeClass(theme),
      ...getClass(digitSize, ClassSelector.digitClass)
    ]"
  >
    {{ digit }}
    <div
      v-if="type === CounterType.complete"
      class="label snail absolute bottom-0 left-0 w-full"
      :class="[...getClass(digitSize, ClassSelector.labelClass)]"
    >
      {{ label }}
    </div>
  </div>
</template>

<style lang="scss" scoped></style>
